export const getParamsUrl = (url?: string): URLSearchParams => {
  try {
    return new URLSearchParams(new URL(url)?.search);
  } catch (error) {}

  return new URLSearchParams('');
};
export const getParamUrl = (param: string, url?: string) => {
  try {
    const urlParam = getParamsUrl(url || window?.location?.href);
    return urlParam.get(param);
  } catch (error) {
    return '';
  }
};
